import * as types from './mutation-types';
import Api from './api';

export const setPage = ({ commit }) => {
  commit(types.SET_PAGE);
};
export const resetPage = ({ commit }) => {
  commit(types.RESET_PAGE);
};

export const setIndexPage = ({ commit }, pageNumber) => {
  commit(types.SET_INDEX_PAGE, pageNumber);
};
export const getExportList = ({ commit }, data) =>
  Api.getExportList(data).then(data => {
    commit(types.SET_EXPORT_LIST, data);
    return data;
  });
export const clearExportList = ({ commit }) => {
  commit(types.SET_EXPORT_LIST, null);
};
export const createExport = (_, data) => Api.createExport(data);
export const getExport = ({ commit }, data) =>
  Api.getExport(data).then(data => {
    commit(types.SET_EXPORT, data);
    return data;
  });
export const patchExport = (_, data) => Api.patchExport(data);
export const clearExport = ({ commit }) => {
  commit(types.SET_EXPORT, null);
};
export const getExportLayout = ({ commit, rootState }, data) =>
  Api.getExportLayout(data).then(data => {
    // -1 means "both" (public and publicFuture)
    if (data && data.public_transport_type === -1) {
      const futureTransportTypeMap = {
        1: 7,
        2: 8,
        3: 9,
        4: 10,
      };

      const futureTransportType = futureTransportTypeMap[rootState['Study'].study.futur_transport_type];

      data.sites.forEach(site => {
        const futureTransportObject = JSON.parse(JSON.stringify(site.transports[0]));
        futureTransportObject.type = futureTransportType;
        site.transports.splice(1, 0, futureTransportObject);
      });
    }

    commit(types.SET_EXPORT_LAYOUT, data);
    commit(types.UPDATE_COMMENT, data.final_comment);
    return data;
  });

export const getExportSiteMap = (_, data) => Api.getExportSiteMap(data);
export const getExportSiteMapCollaborator = (_, data) => Api.getExportSiteMapCollaborator(data);

export const getStudyLightview = (_, data) => Api.getStudyLightview(data);
export const patchExportLayout = (_, data) => Api.patchExportLayout(data);
export const printExport = (_, data) => Api.printExport(data);
export const getExportFile = (_, data) => Api.getExportFile(data);
export const getExportExcel = (_, data) => Api.getExportExcel(data);
export const clearExportLayout = ({ commit }) => {
  commit(types.SET_EXPORT_LAYOUT, null);
};

export const updateLogo = ({ commit }, data) => {
  commit(types.UPDATE_LOGO, data.logo);
};
export const updateGlobalComment = ({ commit }, data) => {
  commit(types.UPDATE_COMMENT, data.comment);
};
